import { Button, soundManager, SoundType, useChipSetStore, t } from '@slot-nx/core'
import { Container, Text } from '@pixi/react'
import { TextStyle, Text as PixiText } from 'pixi.js'
import { useRef } from 'react'
import { useGameStore } from '../domain/game/store/GameStore'
import { formatNumberWithComma } from '../domain/game/util/gameUtil'
import { usePopupStore } from '../domain/popup/popupStore'
import { getPayStake } from '../domain/placeOrder/utils/stakeUtils'
import { spinEvent } from '../domain/spin/SpinUtil'

const textTotalPayStyle = new TextStyle({ align: 'center', fontWeight: 'bold', fill: '#ffffff', fontSize: 63 })
const textConfirmContentStyle = new TextStyle({ align: 'center', fontWeight: 'bold', fill: '#F3E5A1', fontSize: 80 })
const textButtonStyle = new TextStyle({ align: 'center', fontWeight: 'bold', fill: '#F3E5A1', fontSize: 40 })

const BUTTON_WIDTH = 315
const BUTTON_HEIGHT = 83
const CANCEL_BUTTON_X = -340
const OK_BUTTON_X = 40
const BUTTON_Y = 140

interface ConfirmContentProps {
  setShowConfirmContent: React.Dispatch<React.SetStateAction<boolean>>
}

export const ConfirmContent = (props: ConfirmContentProps) => {
  const { setShowConfirmContent } = props
  const [currentIndex, chipSet] = useChipSetStore(x => [x.currentIndex, x.chipSet])
  const betOptionType = useGameStore(x => x.betOptionType)
  const totalPay = formatNumberWithComma(getPayStake(chipSet[currentIndex], betOptionType))
  const cancelTextRef = useRef<PixiText>()
  const okTextRef = useRef<PixiText>()
  const cancelTextX = CANCEL_BUTTON_X + BUTTON_WIDTH / 2
  const okTextX = OK_BUTTON_X + BUTTON_WIDTH / 2
  const buttonTextY = BUTTON_Y + BUTTON_HEIGHT / 2

  return (
    <Container name="ConfirmContent">
      <Text
        text={t('buyBonus_popup_buy_button')}
        x={0}
        y={-200}
        anchor={[0.5, 0.5]}
        style={textConfirmContentStyle}
      />
      <Text
        text={t('buyBonus_popup_free_game')}
        x={0}
        y={-100}
        anchor={[0.5, 0.5]}
        style={textConfirmContentStyle}
      />
      <Container name="total_pay_container" width={794} height={40} x={0} y={20}>
        <Text
          name="total_pay"
          text={totalPay}
          anchor={[0.5]}
          x={0}
          style={textTotalPayStyle}
        />
      </Container>
      <Button
        name="cancel button"
        x={CANCEL_BUTTON_X}
        y={BUTTON_Y}
        width={BUTTON_WIDTH}
        height={BUTTON_HEIGHT}
        defaultView="btn_normal"
        hoverView="btn_hover"
        disabledView="btn_disable"
        pressedView="btn_click"
        onPressing={() => {
          soundManager.play(SoundType.buttonConfirm)
          ;(cancelTextRef.current as PixiText).position.y = buttonTextY + 7
        }}
        onHoverEnd={() => {
          ;(cancelTextRef.current as PixiText).position.y = buttonTextY
        }}
        onPress={() => {
          setShowConfirmContent(false)
        }}
      />
      <Text
        text={t('buyBonus_popup_cancel')}
        x={cancelTextX}
        y={buttonTextY}
        anchor={[0.5, 0.5]}
        name="cancel button text"
        style={textButtonStyle}
        eventMode="passive"
        ref={(el) => {
          cancelTextRef.current = el as PixiText
        }}
      />
      <Button
        name="ok button"
        x={OK_BUTTON_X}
        y={BUTTON_Y}
        width={BUTTON_WIDTH}
        height={BUTTON_HEIGHT}
        defaultView="btn_normal"
        hoverView="btn_hover"
        disabledView="btn_disable"
        pressedView="btn_click"
        onPressing={() => {
          soundManager.play(SoundType.buttonConfirm)
          ;(okTextRef.current as PixiText).position.y = buttonTextY + 7
        }}
        onHoverEnd={() => {
          ;(okTextRef.current as PixiText).position.y = buttonTextY
        }}
        onPress={() => {
          soundManager.play(SoundType.spin)
          usePopupStore.setState({ isOpenBonusGamePopup: false })
          spinEvent()
        }}
      />
      <Text
        text={t('buyBonus_popup_ok')}
        x={okTextX}
        y={buttonTextY}
        anchor={[0.5, 0.5]}
        name="ok button text"
        style={textButtonStyle}
        eventMode="passive"
        ref={(el) => {
          okTextRef.current = el as PixiText
        }}
      />
    </Container>
  )
}
